(function ($) {
  $(".cb-slider-container").flickity({
    // options
    cellAlign: "left",
    contain: true,
    wrapAround: true,
    autoPlay: 1500,
    prevNextButtons: false,
    pageDots: false,
  });

  $(".sample-switcher input").on("click", function () {
    const parentContainer = $(this).parents(".switcher-container");
    if ($(this).is(":checked")) {
      parentContainer.addClass("active");
      $("[data-selling-plan-group-id] label.sls-selling-plan-group-name").click();
    } else {
      parentContainer.removeClass("active");
      $(".sls-option-container label.sls-selling-plan-group-name:first").click();
    }
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".cb_product_subscribe").appendTo(
      $(".product__main__content .product__inner")
    );
  }

  setTimeout(function () {
    $("#free-sample").removeAttr("disabled");
  }, 2000);

  $('input[name="shot-size"]').on("change", function (e) {
    const qtyInput = document.querySelector('[name="quantity"]');
    const newQty = e.currentTarget?.dataset?.cbQty;

    // 1. Sync quantity
    if (qtyInput && newQty != null) {
      qtyInput.value = parseInt(newQty, 10);
      qtyInput.dispatchEvent(new Event("change"));
    }

    // 2. Update header highlight + extra phrase
    $('.cb-discount-value').text($(this).data('discount-value'));
    // const subsHighlight = document.querySelector(".subs-highlight");
    // const extraPhrase = document.querySelector(".subs-extra-phrase");
    // if (subsHighlight && extraPhrase) {
    //   if (newQty === "2") { 
    //     subsHighlight.textContent = "Save 25% Total";
    //     extraPhrase.style.display = "block";
    //   } else {
    //     subsHighlight.textContent = "Save 15%";
    //     extraPhrase.style.display = "none";
    //   }
    // }

    // 3. If subscription active, nudge Seal to refresh prices
    const isSubscribeActive = document.querySelector(
      '.product__subs__group input[name="selling-plan-group"]:checked'
    )?.value;

    if (isSubscribeActive) {
      setTimeout(cbNudgeSealPriceAfterPackChange, 10);
    }
  });

  $("[data-add-to-cart]").on("click", function () {
    document.addEventListener("theme:cart:change", function (event) {
      var cart = event.detail.cart;
      if (cart) {
        const toggle = $("[data-drawer-toggle=drawer-cart]")[0];
        if (toggle) toggle.click();
      }
    }, { once: true });
  });
})(jQuery);

document.addEventListener("sealsubs:price_update", function (e) {
  window.cbSealSRefreshEvent = e;
});

/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this file will make it easier to update Pipeline.
 */

(function () {
  // document.addEventListener('theme:variant:change', function(event) {
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //   }
  // });
  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   console.log(cart)
  //   if (cart) {
  //   }
  // });
})();

// ECOM JS
// DESCRIPTION ACCORDION
const faqs = document.querySelectorAll(".faq-item");
faqs.forEach((faq) => {
  const question = faq.querySelector(".faq-question");
  const answer = faq.querySelector(".faq-answer");
  if (!question || !answer) return;

  question.addEventListener("click", () => {
    faqs.forEach((item) => {
      if (item !== faq) {
        item.classList.remove("active");
        const ans = item.querySelector(".faq-answer");
        if (ans) ans.style.maxHeight = null;
      }
    });
    faq.classList.toggle("active");
    if (faq.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = null;
    }
  });
});

// SUBSCRIPTION VARIANT SYNC
document.addEventListener("theme:variant:change", function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  const variantInput = document.querySelector(
    'form.shopify-product-form input[name="id"]'
  );
  if (variantInput) variantInput.value = variant.id;

  const sealForm = document.querySelector(".sealsubs-target-element");
  if (sealForm) sealForm.setAttribute("data-variant-id", variant.id);
});

// Wire up custom subscription block to Seal's widget
document.addEventListener("DOMContentLoaded", function () {
  const groupRadios = document.querySelectorAll(
    '.product__subs__group input[name="selling-plan-group"]'
  );
  const planRadios = document.querySelectorAll(
    '.product__subs__plans input[name="selling_plan"]'
  );

  groupRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      if (this.value) {
        const sealSubscribe = document.querySelector(
          '[data-selling-plan-group-option-radio] .sls-option'
        );
        if (sealSubscribe) {
          sealSubscribe.click();
          const currentPlan = document.querySelector(
            '.product__subs__plans input[name="selling_plan"]:checked'
          )?.value;
          if (currentPlan) {
            const sel = document.querySelector('.sls-select[name="subs_interval"]');
            if (sel) {
              sel.value = currentPlan;
              sel.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        }
      } else {
        const sealOnetime = document.querySelector(
          '[data-one-time-option-radio] .sls-option'
        );
        if (sealOnetime) sealOnetime.click();
      }
    });
  });

  planRadios.forEach((plan) => {
    plan.addEventListener("change", function () {
      const isSubscribe = document.querySelector(
        '.product__subs__group input[name="selling-plan-group"]:checked'
      )?.value;
      if (!isSubscribe) return;

      const sel = document.querySelector('.sls-select[name="subs_interval"]');
      if (sel) {
        sel.value = this.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});

// Helper: handle pack switch differently for subscribe vs one-time
function cbNudgeSealPriceAfterPackChange() {
  const sealOneTime = document.querySelector(
    '[data-one-time-option-radio] .sls-option'
  );
  const sealSubscribe = document.querySelector(
    '[data-selling-plan-group-option-radio] .sls-option'
  );

  if (!sealOneTime || !sealSubscribe) return;

  const isSubscribeActive = document.querySelector(
    '.product__subs__group input[name="selling-plan-group"]:checked'
  )?.value;

  if (isSubscribeActive) {
    sealOneTime.click();
    setTimeout(() => {
      sealSubscribe.click();
    }, 0);
  } else {
    sealSubscribe.click();
    setTimeout(() => {
      sealOneTime.click();
    }, 0);
  }
}

document.addEventListener("sealsubs:price_update", function () {
  const subRadio = document.querySelector('.product__subs__group input[name="selling-plan-group"]:checked');
  const subPlan  = document.querySelector('.product__subs__plans input[name="selling_plan"]:checked');

  if (subRadio && subPlan) {
    const sealSubscribe = document.querySelector('[data-selling-plan-group-option-radio] .sls-option');
    if (sealSubscribe) {
      setTimeout(() => {
        sealSubscribe.click();
      }, 100);
    }
  }
}, { once: true });

$(document).ready(function() {
  // update atc btn price
  updateAtcPrice();
  $('.cb-option-item').on('change', function() {
    updateAtcPrice();
  });
  $('.product__subs__option:has(input[type=radio]').on('change', function() {
    updateAtcPrice()
  });
});

function updateAtcPrice() {
  var atbPriceEl = $('[data-cb-button-disc-price]');
    // 1215303723992260 update class to .subscription-price and one-time-price
    let priceText = $('.product__subs__option:has(input[type=radio]:checked) .subscription-price').text();
    if(!priceText) {
      priceText = $('.product__subs__option:has(input[type=radio]:checked) .one-time-price').text();
    }
    atbPriceEl.text(priceText);
}